import React from "react";

const formatCount = (count, singular, plural) => {
  const n = Number(count) || 0;
  return `${n.toLocaleString()} ${n === 1 ? singular : plural}`;
};

const WebsiteUsageSummary = ({ websiteUsage, days = 30 }) => {
  if (!websiteUsage?.behaviors?.length && !websiteUsage?.topPages?.length) {
    return (
      <article className="owner-dashboard__panel owner-dashboard__usage">
        <h3 className="owner-dashboard__panel-title">How families use your website</h3>
        <p className="owner-dashboard__panel-subtitle">
          A plain-English summary of what people do on ace-gymnastics.com — browsing
          programs, finding classes, signing up, and more.
        </p>
        <p className="owner-dashboard__usage-note">
          Not enough website activity to summarize yet for the last {days} days.
        </p>
      </article>
    );
  }

  const { headline, behaviors, topPages, highlights, totalTrackedActions } = websiteUsage;

  return (
    <article className="owner-dashboard__panel owner-dashboard__usage">
      <div className="owner-dashboard__panel-header owner-dashboard__panel-header--compact">
        <div>
          <h3 className="owner-dashboard__panel-title">How families use your website</h3>
          <p className="owner-dashboard__panel-subtitle">
            Last {days} days · what people actually do on ace-gymnastics.com
          </p>
        </div>
      </div>

      <p className="owner-dashboard__usage-intro">
        This is not just page views — it tracks real actions like opening a program,
        using the class finder, or clicking Register.
      </p>

      {headline && <p className="owner-dashboard__usage-headline">{headline}</p>}

      {behaviors?.length > 0 && (
        <ul className="owner-dashboard__usage-list">
          {behaviors.slice(0, 6).map((row) => (
            <li key={row.id} className="owner-dashboard__usage-row">
              <div className="owner-dashboard__usage-row-head">
                <span className="owner-dashboard__usage-label">{row.label}</span>
                <span className="owner-dashboard__usage-stats">
                  {formatCount(row.count, "action", "actions")}
                  {totalTrackedActions ? ` · ${row.sharePercent}%` : ""}
                </span>
              </div>
              <div className="owner-dashboard__usage-bar-track" aria-hidden="true">
                <span
                  className="owner-dashboard__usage-bar-fill"
                  style={{ width: `${Math.max(row.sharePercent, 4)}%` }}
                />
              </div>
              {row.description && (
                <p className="owner-dashboard__usage-hint">{row.description}</p>
              )}
            </li>
          ))}
        </ul>
      )}

      {highlights?.length > 0 && (
        <ul className="owner-dashboard__usage-highlights">
          {highlights.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}

      {topPages?.length > 0 && (
        <div className="owner-dashboard__usage-pages">
          <h4 className="owner-dashboard__usage-pages-title">Pages visited most</h4>
          <p className="owner-dashboard__usage-pages-note">
            Where families spend time reading — not every click, but actual page visits.
          </p>
          <ul className="owner-dashboard__usage-pages-list">
            {topPages.map((row) => (
              <li key={row.path}>
                <span>{row.label}</span>
                <strong>{formatCount(row.views, "visit", "visits")}</strong>
              </li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
};

export default WebsiteUsageSummary;
